'use strict';

const registry = {};

function subscribe(event, action) {
  const handlers = registry[event];

  if (!handlers) {
    registry[event] = [];
  }

  registry[event].push(action);
}

function subscribeOnce(event, action) {
  registry[event] = [action];
}

function publish(event, data) {
  const handlers = registry[event] || [];

  handlers.forEach(action => action(data));
}

module.exports = {
  subscribe,
  subscribeOnce,
  publish,
};
